import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/kit";
import { Eraser } from "lucide-react";

export default function SignaturePad({ onChange }) {
  const [mode, setMode] = useState("draw");
  const [typed, setTyped] = useState("");
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const hasDrawn = useRef(false);

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0F172A";
  }, [mode]);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    const t = e.touches ? e.touches[0] : e;
    return { x: t.clientX - r.left, y: t.clientY - r.top };
  };
  const start = (e) => { e.preventDefault(); drawing.current = true; const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); };
  const move = (e) => { if (!drawing.current) return; e.preventDefault(); const ctx = canvasRef.current.getContext("2d"); const p = pos(e); ctx.lineTo(p.x, p.y); ctx.stroke(); hasDrawn.current = true; };
  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    if (hasDrawn.current) onChange({ type: "draw", data: canvasRef.current.toDataURL("image/png") });
  };
  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    hasDrawn.current = false;
    onChange(null);
  };

  return (
    <div>
      <div className="mb-3 flex gap-2">
        <button type="button" data-testid="sig-mode-draw" onClick={() => { setMode("draw"); onChange(null); }}
          className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors ${mode === "draw" ? "bg-amber-500 text-slate-950" : "bg-slate-800 text-slate-300"}`}>
          Rita signatur
        </button>
        <button type="button" data-testid="sig-mode-type" onClick={() => { setMode("type"); setTyped(""); onChange(null); }}
          className={`rounded-lg px-3 py-1.5 text-xs font-semibold transition-colors ${mode === "type" ? "bg-amber-500 text-slate-950" : "bg-slate-800 text-slate-300"}`}>
          Skriv namn
        </button>
      </div>

      {mode === "draw" ? (
        <div className="relative">
          <canvas
            ref={canvasRef}
            data-testid="signature-canvas"
            className="h-44 w-full touch-none rounded-lg border-2 border-dashed border-slate-300 bg-white"
            onMouseDown={start} onMouseMove={move} onMouseUp={end} onMouseLeave={end}
            onTouchStart={start} onTouchMove={move} onTouchEnd={end}
          />
          <button type="button" data-testid="sig-clear-button" onClick={clear}
            className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-md bg-slate-900/80 px-2 py-1 text-xs text-white">
            <Eraser size={12} /> Rensa
          </button>
          <p className="mt-1.5 text-xs text-slate-500">Rita din signatur i rutan ovan</p>
        </div>
      ) : (
        <div className="rounded-lg border border-slate-700 bg-white p-4">
          <input
            data-testid="signature-typed-input"
            value={typed}
            onChange={(e) => { setTyped(e.target.value); onChange(e.target.value ? { type: "type", data: e.target.value } : null); }}
            placeholder="Skriv ditt fullständiga namn"
            className="w-full bg-transparent text-center text-2xl text-slate-900 outline-none"
            style={{ fontFamily: "'Outfit', cursive" }}
          />
        </div>
      )}
    </div>
  );
}
